import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DistrictsService } from '../services/districts.service';
import { edit, DistrictModel } from '../Model/DistrictModel'
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
declare var $: any;

@Component({
  selector: 'app-districts',
  templateUrl: './districts.component.html',
  styleUrls: ['./districts.component.css']
})
export class DistrictsComponent implements OnInit {
  @Output() headerTitle = new EventEmitter<string>();
  DistrictsData: Array<any> = new Array();
  DistrictName: string;
  DistrictCode: string;
  IsActive: any
  isAdmin: boolean = false;
  CreateDistrict: DistrictModel = new DistrictModel();
  SelectedDistrict: DistrictModel = new DistrictModel();
  editmodel: edit = new edit()
  DistrictId: number
  role: any;

  constructor(private DistrictsService: DistrictsService, private router: Router, public datepipe: DatePipe, private Toastr: ToastrService) { }

  ngOnInit() {
    this.CreateDistrict.IsActive = true;
    this.headerTitle.emit("Districts");
    this.role = localStorage.getItem("role")
    if (this.role == 'SuperAdmin') {
      this.isAdmin = true;
    }
    this.DistrictsService.getAllDistrictData().subscribe(data => {
      this.DistrictsData = data;
    },
      error => {
        this.Toastr.error("Something went on the server side !!!");
        // console.log(error);
      });
  }

  SelectedDistrictDetail(data) {
    this.editmodel = data;
  }

  create() {
    this.DistrictsService.AddNewDistrict(this.CreateDistrict).subscribe((resp) => {
      this.Toastr.success('District Created Successfully ');
      this.ngOnInit();
      this.CreateDistrict.DistrictName = '';
      this.CreateDistrict.DistrictCode = '';
    },
      (error) => {
        this.Toastr.error("Something went on the server side !!!");
        // console.log(error);
      });
  }

  Update() {

    this.DistrictsService.UpdateDistrict(this.editmodel).subscribe(resp => {
      this.Toastr.success('District Updated Successfully ');
      $("#editDistrictModal").modal("hide");
      this.ngOnInit();
      // console.log(resp);
    }, err => {
      // console.log(err);
    });
  }
}
